import React from 'react';
import Headroom from 'react-headroom';
import { Container } from 'reactstrap';
import NavArea from './NavArea';
import PersonalInfo from './PersonalInfo';

const Header = () => {
  return (
    <div className="headerPart">
      <Headroom
        style={{
          webkitTransition: 'all .5s ease-in-out',
          mozTransition: 'all .5s ease-in-out',
          oTransition: 'all .5s ease-in-out',
          transition: 'all .5s ease-in-out',
          background: '#0a192f',
          boxShadow: '1px 1px 1px rgba(0,0,0,0.25)',
        }}
      >
        <NavArea />
        <Container></Container>
      </Headroom>
      <Container>
        <PersonalInfo />
      </Container>
    </div>
  );
};

export default Header;
